import React from 'react';
import ReactDOM from 'react-dom';
import { EventsFinderForm } from './components/index.js'

const elements = [...document.querySelectorAll('.events-finder-form')]
elements.forEach(async element => {
    if (element) {
        const events = await fetch('/wp-json/wp/v2/events?per_page=100&orderBy=date&order=asc&_embed=true').then(response => response.json())
        const roles = await fetch('/wp-json/wp/v2/role?per_page=100&page=1&orderBy=date&order=asc&_embed=true').then(response => response.json())
        const eventTypes = await fetch('/wp-json/wp/v2/event_types?per_page=100&page=1&orderBy=date&order=asc&_embed=true').then(response => response.json())
        const countries = await fetch('/wp-json/wp/v2/country?per_page=100&page=1&orderBy=date&order=asc&_embed=true').then(response => response.json())
        const languages = await fetch('/wp-json/wp/v2/language?per_page=100&page=1&orderBy=date&order=asc&_embed=true').then(response => response.json())
        // const {
        //     query,
        //     filterMenuEnabled,
        //     searchEnabled,
        //     selectedTaxonomies,
        //     columns = 3,
        //     rows = 3,
        //     sortByEnabled,
        //     sortByDefault,
        //     sortDirectionDefault,
        //     selectedSortOptions,
        //     loadMoreEnabled,
        //     showTitleImage
        // } = JSON.parse(element.dataset.blockAttributes)
        // // const categories = [381]
        ReactDOM.render(
            <React.StrictMode>
                <EventsFinderForm
                    roles={roles}
                    eventTypes={eventTypes}
                    countries={countries}
                    languages={languages}
                    events={events}
                />
            </React.StrictMode>,
            element
        );
    }
})